// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Attendance — matches Grades / Courses admin shell */

.att-shell {
  display: flex;
  flex-direction: column;
  height: 109vh;
  min-height: 0;
  padding: 10px 50px 0;
  overflow: hidden;
}

.att-banner {
  flex-shrink: 0;
  background-color: #d5d1fd;
  border-radius: 20px;
  padding: 26px 30px;
  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.04);
}

.att-banner__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.att-banner__title {
  margin: 0 0 4px;
  font-weight: 700;
  color: #302d45;
}

.att-banner__subtitle {
  margin: 0;
  color: #625d75;
  font-size: 13px;
}

.att-banner__crumb {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 600;
  color: #625d75;
}

.att-banner__crumb a {
  color: #403b55;
  text-decoration: none;
}

.att-banner__crumb a:hover {
  text-decoration: underline;
}

.att-banner__actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

/* Right-side panel (like Bug Reports): docked right, content left-aligned inside */
.att-banner__controls {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  flex: 1 1 280px;
  max-width: 420px;
  margin-left: auto;
  min-width: 0;
}

.att-banner__control-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
}

.att-banner__control-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #625d75;
  text-align: left;
}

.att-banner__control-hint {
  font-size: 12px;
  color: #625d75;
  text-align: left;
}

.att-spacer {
  height: 16px;
  flex-shrink: 0;
}

.att-control-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding: 14px 18px;
  background: #fff;
  border: 1px solid #eeeaf8;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.05);
}

.att-control-bar--filter {
  margin-top: 10px;
  background: #faf9fd;
}

.att-control-bar__copy {
  min-width: 0;
}

.att-control-bar__label {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #302d45;
}

.att-control-bar__hint {
  margin-top: 3px;
  font-size: 12px;
  color: #77718b;
}

.att-control-bar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.att-btn {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  border-radius: 8px;
  padding: 0 15px;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  color: #403b55;
  background-color: #fff;
  transition: filter 0.15s ease, opacity 0.15s ease;
}

.att-btn:hover:not(:disabled) {
  filter: brightness(0.98);
}

.att-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.att-btn--mint {
  background-color: #bff1db;
  color: #355c4a;
}

.att-btn--lavender {
  background-color: #d5d1fd;
  color: #403b55;
}

.att-btn--peach {
  background-color: #f9e1be;
  color: #654343;
}

.att-btn--pink {
  background-color: #f2c4c4;
  color: #654343;
}

.att-btn--ghost {
  background-color: #f4f1fa;
  color: #514b65;
}

.att-field {
  height: 38px;
  border: 1px solid #ddd8d2;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 13px;
  color: #403b55;
  background: #fff;
}

.att-field:focus {
  outline: 2px solid rgba(213, 204, 253, 0.9);
  outline-offset: 1px;
}

.att-empty {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #77718b;
  text-align: center;
  padding: 24px;
}

.att-empty__title {
  font-size: 18px;
  font-weight: 600;
  color: #403b55;
}

.att-empty__hint {
  margin-top: 5px;
  font-size: 13px;
}

.att-table-wrap {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 14px;
  border: 1px solid #eeeaf8;
  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.05);
}

.att-table-scroll {
  height: 100%;
  overflow: auto;
}

.att-table {
  min-width: 700px;
  width: 100%;
  background: #fff;
  border-collapse: separate;
  border-spacing: 0;
  margin: 0;
}

.att-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #d5d1fd;
  color: #302d45;
  font-weight: 600;
  padding: 13px 14px;
  text-align: center;
  letter-spacing: 0.4px;
  font-size: 13px;
  border-bottom: 1px solid #e6e3f3;
  white-space: nowrap;
}

.att-table tbody td {
  background: #fff;
  padding: 12px 14px;
  text-align: center;
  font-size: 14px;
  color: #403b55;
  border-bottom: 1px solid #f0edf6;
  vertical-align: middle;
}

.att-table tbody tr:hover td {
  background: #faf9fd;
}

.att-table__left {
  text-align: left !important;
}

.att-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 88px;
  border: none;
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.att-chip--present {
  background: #bff1db;
  color: #355c4a;
}

.att-chip--absent {
  background: #eeeaf5;
  color: #77718b;
}

.att-chip:disabled {
  cursor: default;
}

.att-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.att-stats--banner {
  margin-top: 0;
  justify-content: flex-start;
}

.att-stat {
  background: rgba(255, 255, 255, 0.72);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #514b65;
}

.att-stat strong {
  color: #302d45;
  margin-left: 4px;
}

.att-take-grid {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  overflow: hidden;
}

@media (min-width: 960px) {
  .att-take-grid {
    grid-template-columns: minmax(280px, 360px) 1fr;
  }
}

.att-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: #fff;
  border: 1px solid #eeeaf8;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.05);
  overflow: hidden;
}

.att-panel__head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid #eeeaf8;
  background: #faf9fd;
}

.att-panel__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.att-panel__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #302d45;
  letter-spacing: 0.3px;
}

.att-panel__lock {
  font-size: 12px;
  font-weight: 700;
  color: #8a6a3a;
  background: #f9e1be;
  border-radius: 999px;
  padding: 5px 10px;
}

.att-panel__body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 14px 16px;
}

.att-scanner {
  width: 100%;
  min-height: 240px;
  border-radius: 10px;
  overflow: hidden;
  background: #1a1822;
}

.att-feedback {
  margin: 10px 0 0;
  font-size: 13px;
  color: #514b65;
}

.att-feedback--ok {
  color: #355c4a;
  font-weight: 600;
}

.att-feedback--err {
  color: #8a3b3b;
  font-weight: 600;
}

.att-banner-note {
  margin: 12px 0 0;
  font-size: 12px;
  color: #625d75;
}

.att-search {
  width: 100%;
  margin-bottom: 10px;
}

.att-roster {
  list-style: none;
  margin: 0;
  padding: 0;
}

.att-roster__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 4px;
  border-bottom: 1px solid #f0edf6;
}

.att-roster__name {
  font-weight: 600;
  font-size: 14px;
  color: #403b55;
  text-align: left;
}

.att-roster__meta {
  margin-top: 2px;
  font-size: 12px;
  color: #77718b;
  text-align: left;
}

.att-roster--locked {
  opacity: 0.72;
}

.att-switch {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.att-switch__label {
  min-width: 58px;
  text-align: right;
  font-size: 12px;
  font-weight: 700;
  color: #77718b;
}

.att-switch.is-on .att-switch__label {
  color: #355c4a;
}

.att-switch.is-off .att-switch__label {
  color: #77718b;
}

.att-switch input {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin: 0;
  pointer-events: none;
}

.att-switch__track {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  background: #ddd8ea;
  border: 1px solid #cfc8e0;
  transition: background 0.18s ease, border-color 0.18s ease;
  flex-shrink: 0;
}

.att-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(45, 40, 70, 0.22);
  transition: transform 0.18s ease;
}

.att-switch.is-on .att-switch__track {
  background: #7ed9b0;
  border-color: rgba(91, 160, 122, 0.45);
}

.att-switch.is-on .att-switch__thumb {
  transform: translateX(20px);
}

.att-switch input:focus-visible + .att-switch__track {
  outline: 2px solid #6b63b5;
  outline-offset: 2px;
}

.att-switch.is-disabled,
.att-switch:has(input:disabled) {
  cursor: not-allowed;
  opacity: 0.72;
}

@media (max-width: 768px) {
  .att-shell {
    padding: 10px 16px 0;
    height: auto;
    min-height: calc(100vh - 80px);
    overflow: visible;
  }

  .att-banner {
    padding: 18px 16px;
  }

  .att-table-wrap {
    margin-bottom: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/AdminAttendance.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;AACjB;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Admin Attendance — matches Grades / Courses admin shell */\n\n.att-shell {\n  display: flex;\n  flex-direction: column;\n  height: 109vh;\n  min-height: 0;\n  padding: 10px 50px 0;\n  overflow: hidden;\n}\n\n.att-banner {\n  flex-shrink: 0;\n  background-color: #d5d1fd;\n  border-radius: 20px;\n  padding: 26px 30px;\n  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.04);\n}\n\n.att-banner__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.att-banner__title {\n  margin: 0 0 4px;\n  font-weight: 700;\n  color: #302d45;\n}\n\n.att-banner__subtitle {\n  margin: 0;\n  color: #625d75;\n  font-size: 13px;\n}\n\n.att-banner__crumb {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #625d75;\n}\n\n.att-banner__crumb a {\n  color: #403b55;\n  text-decoration: none;\n}\n\n.att-banner__crumb a:hover {\n  text-decoration: underline;\n}\n\n.att-banner__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Right-side panel (like Bug Reports): docked right, content left-aligned inside */\n.att-banner__controls {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 12px;\n  flex: 1 1 280px;\n  max-width: 420px;\n  margin-left: auto;\n  min-width: 0;\n}\n\n.att-banner__control-group {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  width: 100%;\n}\n\n.att-banner__control-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #625d75;\n  text-align: left;\n}\n\n.att-banner__control-hint {\n  font-size: 12px;\n  color: #625d75;\n  text-align: left;\n}\n\n.att-spacer {\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.att-control-bar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n  padding: 14px 18px;\n  background: #fff;\n  border: 1px solid #eeeaf8;\n  border-radius: 14px;\n  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.05);\n}\n\n.att-control-bar--filter {\n  margin-top: 10px;\n  background: #faf9fd;\n}\n\n.att-control-bar__copy {\n  min-width: 0;\n}\n\n.att-control-bar__label {\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #302d45;\n}\n\n.att-control-bar__hint {\n  margin-top: 3px;\n  font-size: 12px;\n  color: #77718b;\n}\n\n.att-control-bar__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.att-btn {\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: none;\n  border-radius: 8px;\n  padding: 0 15px;\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-decoration: none;\n  color: #403b55;\n  background-color: #fff;\n  transition: filter 0.15s ease, opacity 0.15s ease;\n}\n\n.att-btn:hover:not(:disabled) {\n  filter: brightness(0.98);\n}\n\n.att-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.att-btn--mint {\n  background-color: #bff1db;\n  color: #355c4a;\n}\n\n.att-btn--lavender {\n  background-color: #d5d1fd;\n  color: #403b55;\n}\n\n.att-btn--peach {\n  background-color: #f9e1be;\n  color: #654343;\n}\n\n.att-btn--pink {\n  background-color: #f2c4c4;\n  color: #654343;\n}\n\n.att-btn--ghost {\n  background-color: #f4f1fa;\n  color: #514b65;\n}\n\n.att-field {\n  height: 38px;\n  border: 1px solid #ddd8d2;\n  border-radius: 8px;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #403b55;\n  background: #fff;\n}\n\n.att-field:focus {\n  outline: 2px solid rgba(213, 204, 253, 0.9);\n  outline-offset: 1px;\n}\n\n.att-empty {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #77718b;\n  text-align: center;\n  padding: 24px;\n}\n\n.att-empty__title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #403b55;\n}\n\n.att-empty__hint {\n  margin-top: 5px;\n  font-size: 13px;\n}\n\n.att-table-wrap {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  margin-top: 10px;\n  background-color: #fff;\n  border-radius: 14px;\n  border: 1px solid #eeeaf8;\n  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.05);\n}\n\n.att-table-scroll {\n  height: 100%;\n  overflow: auto;\n}\n\n.att-table {\n  min-width: 700px;\n  width: 100%;\n  background: #fff;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin: 0;\n}\n\n.att-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background: #d5d1fd;\n  color: #302d45;\n  font-weight: 600;\n  padding: 13px 14px;\n  text-align: center;\n  letter-spacing: 0.4px;\n  font-size: 13px;\n  border-bottom: 1px solid #e6e3f3;\n  white-space: nowrap;\n}\n\n.att-table tbody td {\n  background: #fff;\n  padding: 12px 14px;\n  text-align: center;\n  font-size: 14px;\n  color: #403b55;\n  border-bottom: 1px solid #f0edf6;\n  vertical-align: middle;\n}\n\n.att-table tbody tr:hover td {\n  background: #faf9fd;\n}\n\n.att-table__left {\n  text-align: left !important;\n}\n\n.att-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 88px;\n  border: none;\n  border-radius: 8px;\n  padding: 7px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.att-chip--present {\n  background: #bff1db;\n  color: #355c4a;\n}\n\n.att-chip--absent {\n  background: #eeeaf5;\n  color: #77718b;\n}\n\n.att-chip:disabled {\n  cursor: default;\n}\n\n.att-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.att-stats--banner {\n  margin-top: 0;\n  justify-content: flex-start;\n}\n\n.att-stat {\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #514b65;\n}\n\n.att-stat strong {\n  color: #302d45;\n  margin-left: 4px;\n}\n\n.att-take-grid {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 14px;\n  overflow: hidden;\n}\n\n@media (min-width: 960px) {\n  .att-take-grid {\n    grid-template-columns: minmax(280px, 360px) 1fr;\n  }\n}\n\n.att-panel {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background: #fff;\n  border: 1px solid #eeeaf8;\n  border-radius: 14px;\n  box-shadow: 0 2px 10px rgba(48, 45, 69, 0.05);\n  overflow: hidden;\n}\n\n.att-panel__head {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #eeeaf8;\n  background: #faf9fd;\n}\n\n.att-panel__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.att-panel__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #302d45;\n  letter-spacing: 0.3px;\n}\n\n.att-panel__lock {\n  font-size: 12px;\n  font-weight: 700;\n  color: #8a6a3a;\n  background: #f9e1be;\n  border-radius: 999px;\n  padding: 5px 10px;\n}\n\n.att-panel__body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 14px 16px;\n}\n\n.att-scanner {\n  width: 100%;\n  min-height: 240px;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #1a1822;\n}\n\n.att-feedback {\n  margin: 10px 0 0;\n  font-size: 13px;\n  color: #514b65;\n}\n\n.att-feedback--ok {\n  color: #355c4a;\n  font-weight: 600;\n}\n\n.att-feedback--err {\n  color: #8a3b3b;\n  font-weight: 600;\n}\n\n.att-banner-note {\n  margin: 12px 0 0;\n  font-size: 12px;\n  color: #625d75;\n}\n\n.att-search {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.att-roster {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.att-roster__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 4px;\n  border-bottom: 1px solid #f0edf6;\n}\n\n.att-roster__name {\n  font-weight: 600;\n  font-size: 14px;\n  color: #403b55;\n  text-align: left;\n}\n\n.att-roster__meta {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #77718b;\n  text-align: left;\n}\n\n.att-roster--locked {\n  opacity: 0.72;\n}\n\n.att-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  flex-shrink: 0;\n  cursor: pointer;\n  user-select: none;\n}\n\n.att-switch__label {\n  min-width: 58px;\n  text-align: right;\n  font-size: 12px;\n  font-weight: 700;\n  color: #77718b;\n}\n\n.att-switch.is-on .att-switch__label {\n  color: #355c4a;\n}\n\n.att-switch.is-off .att-switch__label {\n  color: #77718b;\n}\n\n.att-switch input {\n  position: absolute;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n  margin: 0;\n  pointer-events: none;\n}\n\n.att-switch__track {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  border-radius: 999px;\n  background: #ddd8ea;\n  border: 1px solid #cfc8e0;\n  transition: background 0.18s ease, border-color 0.18s ease;\n  flex-shrink: 0;\n}\n\n.att-switch__thumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(45, 40, 70, 0.22);\n  transition: transform 0.18s ease;\n}\n\n.att-switch.is-on .att-switch__track {\n  background: #7ed9b0;\n  border-color: rgba(91, 160, 122, 0.45);\n}\n\n.att-switch.is-on .att-switch__thumb {\n  transform: translateX(20px);\n}\n\n.att-switch input:focus-visible + .att-switch__track {\n  outline: 2px solid #6b63b5;\n  outline-offset: 2px;\n}\n\n.att-switch.is-disabled,\n.att-switch:has(input:disabled) {\n  cursor: not-allowed;\n  opacity: 0.72;\n}\n\n@media (max-width: 768px) {\n  .att-shell {\n    padding: 10px 16px 0;\n    height: auto;\n    min-height: calc(100vh - 80px);\n    overflow: visible;\n  }\n\n  .att-banner {\n    padding: 18px 16px;\n  }\n\n  .att-table-wrap {\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
